//constant
import { EXPERIMENTS_VALUES } from "@payment-client/constants/Experiments";

//internal-deps
import { ConfirmOrderActionPayload } from "@swiggy-private/checkout-core";

//defs
import { Props } from "./AutopayPaymentFailureScreenContent";

export const checkIfVariant = (data: Pick<Props, "payload" | "successPayload">, variantType: string) => {
    return (
        data.payload?.autoPayPaymentFailureVariant === variantType ||
        data.successPayload?.placeOrderData.extraParams?.pay_on_delivery?.variant === variantType
    );
};

export const checkIsConsentVariantInPlaceOrder = (payload: ConfirmOrderActionPayload) => {
    return (
        EXPERIMENTS_VALUES.AUTOPAY_PHASE_2.CONSENT ===
        payload?.placeOrderData?.extraParams?.pay_on_delivery?.variant?.toUpperCase()
    );
};

export const getAutoPayVariantType = (data: Pick<Props, "payload" | "successPayload">) => {
    const isConsentMode = checkIfVariant(
        {
            payload: data.payload,
            successPayload: data.successPayload,
        },
        EXPERIMENTS_VALUES.AUTOPAY_PHASE_2.CONSENT,
    );

    const isSubtleAutoPlace = checkIfVariant(
        { payload: data.payload, successPayload: data.successPayload },
        EXPERIMENTS_VALUES.AUTOPAY_PHASE_2.SUBTLE_AUTOPLACE,
    );

    return { isConsentMode, isSubtleAutoPlace };
};
